import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import { color } from '../../../styles/styles.js';
var StyledBadge = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5px 10px;\n  border-radius: 5px;\n  width: fit-content;\n  background-color: ", ";\n  border: solid 1px\n    ", ";\n  color: ", ";\n"], ["\n  padding: 5px 10px;\n  border-radius: 5px;\n  width: fit-content;\n  background-color: ", ";\n  border: solid 1px\n    ", ";\n  color: ", ";\n"])), function (props) {
  return props.theme === 'dark' ? color.darkModeDarker : 'transparent';
}, function (props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.danger;

    case 'warning':
      return color.warning;

    case 'info':
      return color.info;

    case 'success':
      return color.success;

    default:
      return props.theme === 'dark' ? color.medium : '#333';
  }
}, function (props) {
  return props.theme === 'dark' ? color.medium : '#333';
});
var templateObject_1;
export { StyledBadge };